<template>
  <v-container fluid class="fullHeight">
    <v-layout column class="fullHeight">
      <v-flex xs12 class="fullHeight" v-if="admin">
        <v-tabs
          v-model="tabsValue"
          align-with-title
          color="secundary"
          slider-color="red"
          dark
        >
          <v-tab v-for="(item, i) in tabs" :key="i">
            {{ item.name }}
          </v-tab>
          <v-layout row align-end>
          </v-layout>
          <info :title="info.title" :content="info.content"/>
        </v-tabs>
        <v-tabs-items v-model="tabsValue" fixed-tabs class="fullHeight">
          <v-tab-item class="fullHeight" v-for="(item, i) in tabs" :key="i">
            <v-card class="fullHeight">
              <component :is="item.chart" class="fullHeight"/>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import InfoDialog from './Misc/InfoDialog'
import axios from 'axios'

export default {
  data () {
    return {
      currentUser: {},
      admin: false,
      tabs: [
        /*{
          name: this.$vuetify.t('$vuetify.charts.surveyAnswers.legend'),
          chart: 'survey'
        }*/
      ],
      tabsValue: null,
      info: {
        title: this.$vuetify.t('$vuetify.info.time.title'),
        content: [
          this.$vuetify.t('$vuetify.info.time.content.1'),
          this.$vuetify.t('$vuetify.info.time.content.2')
        ]
      }
    }
  },
  props: {
    graph: {
      type: Number,
      required: false,
      default: 0
    }
  },
  watch: {
    tabsValue (value) {
      this.$router.replace(this.$route.path + '?graph=' + value)
    }
  },
  mounted () {
    this.tabsValue = this.graph
  },
  components: {
    'info': InfoDialog,
  },
  name: 'Time'
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.fullHeight {
  height : calc(100% - 25px);
}
.tabText {
  text-decoration-color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/Survey.vue